import * as React from "react";
const SvgQuestionCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.17708 6.91853C7.32391 6.50113 7.61373 6.14917 7.99519 5.92498C8.37666 5.70079 8.82516 5.61884 9.26126 5.69364C9.69736 5.76844 10.0929 5.99517 10.3779 6.33367C10.6628 6.67217 10.8188 7.1006 10.8181 7.54306C10.8181 8.79213 8.94452 9.41667 8.94452 9.41667M8.96745 11.9167H8.97578M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
      stroke: "#9195A1",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgQuestionCircle;
